import React from "react";
// import heroImage from "/images/classicroom2.JPG"
// import confer from "/public/images/cop1.jpg"

const Hero = () => {
  return (

    <div
      className="hero-section text-white text-center d-flex align-items-center justify-content-center"
      style={{
        backgroundImage: `url(/images/corpo/hero.jpg)`,
        backgroundSize: "cover",
        
        backgroundPosition: "center",
        height: "60vh",
        position: "relative",
      }}
    >
      <div
        className=" corpo-hero-card  p-4 rounded"
        style={{ maxWidth: "90%" }}
      >
        <h1 className="display-6 fw-bold" style={{color:"#AD8B3A"}}>CORPORATE </h1>
        {/* <p className="lead">IHCL BUSINESS CONNECT</p> */}
      </div>
    </div>
  );
};

export default Hero;
